module.exports = __webpack_public_path__ + "static/june-4-fe9773389c8400e979721d518ead3fa3.png";